module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-layout', {
    staticClass: "list-layout",
    attrs: {
      "pageSize": _vm.pageSize,
      "currentPage": _vm.currentPage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleChange,
      "size-change": _vm.handleSizeChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("代管库查询")]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "slot": "btn_tabs"
    },
    slot: "btn_tabs"
  }, [_c('el-tabs', {
    staticClass: "tab",
    attrs: {
      "value": _vm.activename
    },
    on: {
      "tab-click": _vm.btnTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "disabled": _vm.IsLoading,
      "label": "代管总库存",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "disabled": _vm.IsLoading,
      "label": "租赁代管库",
      "name": "lease"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "disabled": _vm.IsLoading,
      "label": "自有代管库",
      "name": "self"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "slot": "search-bar",
      "inline": true
    },
    slot: "search-bar"
  }, [_c('el-form-item', {
    attrs: {
      "label": "物料名称"
    }
  }, [_c('el-input', {
    staticClass: "form-input",
    attrs: {
      "placeholder": "请输入物料名称／物料编码／客户物料名称／客户物料编码"
    },
    model: {
      value: (_vm.Search.Product),
      callback: function($$v) {
        _vm.Search.Product = $$v
      },
      expression: "Search.Product"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区域"
    }
  }, [_c('el-select', {
    staticClass: "form-input",
    attrs: {
      "filterable": "",
      "placeholder": "请选择或输入区域"
    },
    model: {
      value: (_vm.Search.Region),
      callback: function($$v) {
        _vm.Search.Region = $$v
      },
      expression: "Search.Region"
    }
  }, _vm._l((_vm.Regions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌"
    }
  }, [_c('el-select', {
    staticClass: "form-input",
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择或输入品牌"
    },
    on: {
      "change": _vm.changeBrand
    },
    model: {
      value: (_vm.Search.BrandName),
      callback: function($$v) {
        _vm.Search.BrandName = $$v
      },
      expression: "Search.BrandName"
    }
  }, _vm._l((_vm.BrandNames), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "机型"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择或输入机型"
    },
    model: {
      value: (_vm.Search.ProductModel),
      callback: function($$v) {
        _vm.Search.ProductModel = $$v
      },
      expression: "Search.ProductModel"
    }
  }, _vm._l((_vm.ProductModels), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "模块"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择或输入模块"
    },
    model: {
      value: (_vm.Search.ProductModule),
      callback: function($$v) {
        _vm.Search.ProductModule = $$v
      },
      expression: "Search.ProductModule"
    }
  }, _vm._l((_vm.ProductModules), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品项"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择或输入品项"
    },
    model: {
      value: (_vm.Search.ProductCondition),
      callback: function($$v) {
        _vm.Search.ProductCondition = $$v
      },
      expression: "Search.ProductCondition"
    }
  }, _vm._l((_vm.ProductConditions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.IsLoading
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_area",
    attrs: {
      "slot": "table_area"
    },
    slot: "table_area"
  }, [_c('div', {
    staticClass: "order-box"
  }, [(_vm.activename != 'all') ? _c('el-button', {
    staticClass: "add-btn",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toShipOrder()
      }
    }
  }, [_vm._v("发货通知单\n        "), (this.shipbox.length != 0) ? _c('span', [_vm._v(_vm._s(this.shipbox.length))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activename != 'all') ? _c('el-button', {
    staticClass: "add-btn add-btn1",
    staticStyle: {
      "margin-left": "10px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toDispatch()
      }
    }
  }, [_vm._v("调度申请单\n        "), (this.managedbox.length != 0) ? _c('span', [_vm._v(_vm._s(this.managedbox.length))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activename == 'self' && _vm.activename != 'all') ? _c('el-button', {
    staticClass: "add-btn",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toTrustapply()
      }
    }
  }, [_vm._v("委托申请单\n        "), (this.trustbox.length != 0) ? _c('span', [_vm._v(_vm._s(this.trustbox.length))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('td', [_vm._v("物料名称／编码")]), _vm._v(" "), _c('td', [_vm._v("客户物料名称／编码")]), _vm._v(" "), _c('td', [_vm._v("品项")]), _vm._v(" "), _c('td', [_vm._v("品牌")]), _vm._v(" "), _c('td', [_vm._v("机型")]), _vm._v(" "), _c('td', [_vm._v("模块")]), _vm._v(" "), _c('td', [_vm._v("库存数量")]), _vm._v(" "), _c('td', [_vm._v("区域")]), _vm._v(" "), _c('td', [_vm._v("操作")])])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中"
    }
  }, _vm._l((_vm.tableData), function(item) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "230"
      }
    }, [_vm._v("\n            " + _vm._s(item.ProductName)), _c('br'), _vm._v("物料编码： " + _vm._s(item.ProductCode) + "\n          ")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "230"
      }
    }, [_vm._v(_vm._s(item.CustomerProductName)), _c('br'), _vm._v("物料编码： " + _vm._s(item.CustomerProductCode))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_c('el-tag', {
      attrs: {
        "type": _vm._f("ConditionColor")(item.ConditionName)
      }
    }, [_vm._v(_vm._s(item.ConditionName))])], 1), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v(_vm._s(item.ProductBrandName))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v(_vm._s(item.ProductModelName))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "100"
      }
    }, [_vm._v(_vm._s(item.ProductModuleName))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "80"
      }
    }, [_vm._v(_vm._s(item.Quantity))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "80"
      }
    }, [_vm._v(_vm._s(item.RegionName))]), _vm._v(" "), (_vm.activename != 'all') ? _c('td', {
      attrs: {
        "width": "300"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.todetail(item)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), (_vm.activename == 'self') ? _c('div', {
      staticClass: "inline_box"
    }, [(_vm.ifAddManaged(item) && item.Quantity > 0) ? _c('el-button', {
      staticStyle: {
        "margin-left": "0px"
      },
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.addmanaged(item)
        }
      }
    }, [_vm._v("加入委托")]) : (!_vm.ifAddManaged(item) || item.Quantity > 0) ? _c('el-button', {
      staticStyle: {
        "margin-left": "0px"
      },
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.cancelmanaged(item)
        }
      }
    }, [_vm._v("取消加入委托")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "inline_box"
    }, [(_vm.ifAddDispatch(item) && item.Quantity > 0) ? _c('el-button', {
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.adddispatch(item)
        }
      }
    }, [_vm._v("加入调度")]) : (!_vm.ifAddDispatch(item) || item.Quantity > 0) ? _c('el-button', {
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.canceldispatch(item)
        }
      }
    }, [_vm._v("取消加入调度")]) : _vm._e()], 1), _vm._v(" "), (_vm.activename != 'lease') ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "inline_box"
    }, [(_vm.ifAddShip(item) && item.Quantity > 0) ? _c('el-button', {
      staticStyle: {
        "margin-left": "0px"
      },
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.addship(item)
        }
      }
    }, [_vm._v("加入发货")]) : (!_vm.ifAddShip(item) || item.Quantity > 0) ? _c('el-button', {
      staticStyle: {
        "margin-left": "0px"
      },
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.cancelShip(item)
        }
      }
    }, [_vm._v("取消加入发货")]) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setLimit(item)
        }
      }
    }, [_vm._v("上下限设置")])], 1) : _c('td', {
      attrs: {
        "width": "200"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.todetail(item)
        }
      }
    }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "size": "mini"
      },
      nativeOn: {
        "click": function($event) {
          _vm.setLimit(item)
        }
      }
    }, [_vm._v("上下限设置")])], 1)])
  }))]), _vm._v(" "), _c('el-dialog', {
    staticClass: "pop-box",
    attrs: {
      "title": "上下限设置",
      "size": "small"
    },
    model: {
      value: (_vm.setLimitFormVisible),
      callback: function($$v) {
        _vm.setLimitFormVisible = $$v
      },
      expression: "setLimitFormVisible"
    }
  }, [_c('el-form', [_c('div', {
    staticClass: "form-item"
  }, [_c('el-form-item', {
    attrs: {
      "label": "设置上限",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.uplimit),
      callback: function($$v) {
        _vm.uplimit = _vm._n($$v)
      },
      expression: "uplimit"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-item"
  }, [_c('el-form-item', {
    attrs: {
      "label": "设置下限",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入",
      "min": "0",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.downlimit),
      callback: function($$v) {
        _vm.downlimit = _vm._n($$v)
      },
      expression: "downlimit"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.setLimitFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.suresetLimit()
      }
    }
  }, [_vm._v("完 成")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7323a896"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Inventory/ManagedListPage.vue
// module id = 753
// module chunks = 0